import { z } from "zod";
import moment from "moment";

import { Command } from "../../types";

export const exportSmartaBankingTransactionsRequestSchema = z.object({
  command: z.literal(Command.ExportSmartaBankingTransactions),

  dateRange: z
    .tuple([
      z.custom<moment.Moment>((value) => moment.isMoment(value), {
        message: "Invalid moment object",
      }),
      z.custom<moment.Moment>((value) => moment.isMoment(value), {
        message: "Invalid moment object",
      }),
    ])
    .optional(),
});

export type ExportSmartaBankingTransactionsFormValues = z.infer<
  typeof exportSmartaBankingTransactionsRequestSchema
>;
